import React from "react";

import "../styles.scss";
import "../scripts";

import {
  KameleonElement,
  primaryCollectionBlock,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import {
  blockConfig,
  ContentCollectionItem,
  ContentCollectionItemType,
} from "./components/content-collection-item";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import {
  ContentCollectionType as ComponentType,
  layoutOptions,
} from "./types/prop-types";

type ContentCollectionType = {
  PrimaryBlocks: ContentCollectionItemType[];
} & ComponentType;

export const ContentCollection = primaryCollectionBlock<ContentCollectionType>(
  blockConfig,
  ({ PrimaryBlocks }: ContentCollectionType) => (
    <Box className="primary-collection-content-collection-two-col-stacking-layouts-v1 section_layout357 layout357_component">
      {PrimaryBlocks?.slice(0, 4).map((primaryBlockProps, i) => (
        <Box
          key={i}
          id={`content-collection-item_${i}`}
          className="content-collection-item__position"
          sx={{ top: `${i * 4}rem` }}
        >
          <ContentCollectionItem _index={i} {...primaryBlockProps} />
        </Box>
      ))}
    </Box>
  )
);

ContentCollection.defaultProps =
  getDefaultProps<ContentCollectionType>(defaults);

export const Element: KameleonElement = {
  component: ContentCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
